if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.prevButton = this.querySelector('[data-modal-previous]');
        this.nextButton = this.querySelector('[data-modal-next]');

        this.preventPointerClose = (event) => {
          event.stopPropagation();
        };

        if (this.prevButton) {
          this.prevButton.addEventListener('pointerup', this.preventPointerClose);
          this.prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.switchMedia(-1);
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('pointerup', this.preventPointerClose);
          this.nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.switchMedia(1);
          });
        }

        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowLeft') {
            event.preventDefault();
            this.switchMedia(-1);
          }

          if (event.code === 'ArrowRight') {
            event.preventDefault();
            this.switchMedia(1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      connectedCallback() {
        super.connectedCallback();
        this.updateNavigationState();
      }

      showActiveMedia(mediaId) {
        const targetMediaId =
          mediaId || this.openedBy?.getAttribute('data-media-id') || this.currentMediaId;
        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));

        if (!mediaElements.length) return;

        let activeMedia = this.querySelector(`[data-media-id="${targetMediaId}"]`);
        if (!activeMedia) {
          activeMedia = mediaElements[0];
        }

        mediaElements
          .filter((element) => element !== activeMedia)
          .forEach((element) => element.classList.remove('active'));

        activeMedia.classList.add('active');
        this.currentMediaId = activeMedia.dataset.mediaId;
        activeMedia.scrollIntoView({ block: 'nearest', inline: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container) {
          const activeWidth = activeMedia.clientWidth || activeMedia.width || 0;
          const offset = Math.max(0, (activeWidth - container.clientWidth) / 2);
          container.scrollLeft = offset;
        }

        const activeMediaTemplate =
          typeof activeMedia.querySelector === 'function' ? activeMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        this.updateNavigationState();
      }

      switchMedia(direction) {
        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        if (mediaElements.length < 2) return;

        let currentIndex = mediaElements.findIndex((element) => element.dataset.mediaId === this.currentMediaId);
        if (currentIndex === -1) {
          currentIndex = mediaElements.findIndex((element) => element.classList.contains('active'));
        }
        if (currentIndex === -1) currentIndex = 0;

        const targetIndex = Math.min(Math.max(currentIndex + direction, 0), mediaElements.length - 1);

        if (targetIndex === currentIndex) return;

        const targetMedia = mediaElements[targetIndex];
        this.showActiveMedia(targetMedia.dataset.mediaId);
      }

      updateNavigationState() {
        if (!this.prevButton && !this.nextButton) return;

        const mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        const hasMultiple = mediaElements.length > 1;

        if (!hasMultiple) {
          this.prevButton?.setAttribute('hidden', '');
          this.nextButton?.setAttribute('hidden', '');
          return;
        }

        this.prevButton?.removeAttribute('hidden');
        this.nextButton?.removeAttribute('hidden');

        let activeIndex = mediaElements.findIndex((element) => element.dataset.mediaId === this.currentMediaId);
        if (activeIndex === -1) {
          activeIndex = mediaElements.findIndex((element) => element.classList.contains('active'));
        }
        if (activeIndex === -1) activeIndex = 0;

        this.toggleNavigationButton(this.prevButton, activeIndex <= 0);
        this.toggleNavigationButton(this.nextButton, activeIndex >= mediaElements.length - 1);
      }

      toggleNavigationButton(button, disabled) {
        if (!button) return;
        button.disabled = disabled;
        button.setAttribute('aria-disabled', disabled);
      }
    }
  );
}
